import useGetBookingDetails from '@/features/dashboard/bookings/hooks/useGetBookingDetails.ts';
import { bookingDetailsMapper } from '@/features/dashboard/bookingChanges/types/BookingDetailsDto.mapper.ts';
import RelatedPeopleCard from './RelatedPeopleCard';
import RelatedPeopleCardSkeleton from './RelatedPeopleCardSkeleton';

interface RelatedPeopleSectionProps {
  bookingId: string;
  /** Osoba, na której ekranie stoimy — jej wiersz nie jest odnośnikiem. */
  currentPersonId?: string;
}

/** Obsada rezerwacji — jedyna karta obecna w obu trybach. */
const RelatedPeopleSection = ({
  bookingId,
  currentPersonId,
}: RelatedPeopleSectionProps) => {
  const bookingQuery = useGetBookingDetails(bookingId);

  if (bookingQuery.isLoading) {
    return <RelatedPeopleCardSkeleton />;
  }

  if (!bookingQuery.data) {
    return null;
  }

  return (
    <RelatedPeopleCard
      people={bookingDetailsMapper.toRelatedPeople(
        bookingQuery.data,
        currentPersonId,
      )}
    />
  );
};

export default RelatedPeopleSection;
